import React from 'react';
import s from './Tabs.module.css';

// A horizontal tab strip. Which tab is current stays with the caller, since it
// usually decides what to render underneath.
export default function Tabs({ tabs, current, onChange }) {
  return (
    <div className={s.tabs}>
      {tabs.map((label, i) => (
        <button
          key={label}
          className={[s.tab, i === current ? s.tabOn : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(i)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
